import { forwardRef, InputHTMLAttributes, ReactNode } from 'react'
import cn from 'classnames'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
  endIcon?: ReactNode
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, endIcon, className, id, ...rest }, ref) => (
    <div className="mt-2 w-full">
      {label && (
        <label htmlFor={id} className="text-sm font-medium not-italic text-neutral-darkest">
          {label}
        </label>
      )}
      <div className="relative">
        <input
          ref={ref}
          id={id}
          className={cn(
            'border-neutral-normal-lighter text-neutral-darkest placeholder:text-neutral-normal-lighter mt-1 h-12 w-full rounded border bg-transparent ps-3 text-lg outline-none xxs:ps-4',
            !!endIcon && 'pe-10',
            className,
          )}
          {...rest}
        />
        {endIcon}
      </div>
      {error !== undefined && (
        <p className="text-error-medium-light h-6 text-xs">{error}</p>
      )}
    </div>
  ),
)

Input.displayName = 'Input'
